import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';

const Home = () => {
  const { t, isRTL } = useLanguage();
  const typingRef = useRef(null);
  const typedInstance = useRef(null);

  useEffect(() => {
    // Copie locale des refs pour le cleanup (règle ESLint react-hooks/exhaustive-deps)
    const typingEl = typingRef.current;
    let localTyped = null;

    const timeout = setTimeout(async () => {
      // 1. Détruire l'instance précédente
      if (typedInstance.current) {
        typedInstance.current.destroy();
        typedInstance.current = null;
      }

      // 2. Vider le contenu résiduel
      if (typingEl) {
        typingEl.innerHTML = '';
      }

      // 3. Créer la nouvelle instance
      try {
        const Typed = (await import('typed.js')).default;
        if (typingEl) {
          localTyped = new Typed(typingEl, {
            strings: t.home.typingStrings,
            typeSpeed: 80,
            backSpeed: 50,
            backDelay: 1500,
            startDelay: 200,
            loop: true,
            smartBackspace: false,
          });
          typedInstance.current = localTyped;
        }
      } catch (e) {
        console.error('Typed.js load error:', e);
      }
    }, 50);

    // Cleanup : on utilise les variables locales, pas les refs directement
    return () => {
      clearTimeout(timeout);
      if (localTyped) {
        localTyped.destroy();
        typedInstance.current = null;
      }
      if (typingEl) {
        typingEl.innerHTML = '';
      }
    };
  }, [t.home.typingStrings]);

  const handleContact = (e) => {
    e.preventDefault();
    const target = document.querySelector('#contact');
    if (target) window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
  };

  return (
    <section id="home" className="flex items-center bg-bg-black-900 px-5 py-10">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-center">
          <div className={`w-full md:w-3/5 mb-10 md:mb-0 ${isRTL ? 'md:pl-8' : 'md:pr-8'}`}>
            <h3 className="text-2xl font-semibold my-4">
              {t.home.greeting}{' '}
              <span className="font-clicker text-3xl font-bold text-skin-color">Nathan Benais</span>
            </h3>
            <h3 className="text-2xl font-semibold my-4">
              {t.home.iam}{' '}
              <span className="text-skin-color" ref={typingRef}></span>
            </h3>
            <p className="mb-10 text-base text-text-black-700">
              {t.home.description}
            </p>
            <a
              href="#contact"
              onClick={handleContact}
              className="text-sm font-medium py-3 px-8 text-white rounded-full inline-block whitespace-nowrap shadow-lg border-none transition-all duration-300 hover:scale-105 focus:outline-none"
              style={{ backgroundColor: 'var(--skin-color)', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2)' }}
            >
              <span className="flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`h-4 w-4 ${isRTL ? 'ml-2' : 'mr-2'}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                {t.home.contactBtn}
              </span>
            </a>
          </div>

          <div className="w-full mt-4 md:w-2/5 justify-center hidden md:flex">
            <div className="relative home-img">
              <img
                src="images/Photo_de_Profile/PP.jpg"
                alt="Profile"
                className="mx-auto rounded h-96 w-72 object-cover relative z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;